module.exports = __webpack_public_path__ + "assets/img/Deauville_006.1abc5d45.jpg";